"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_SIZE = void 0;
exports.SET_SIZE = '@sok/web/viewport/SET_SIZE';
